firebird.controller('camaroDetectorCtrl', [
    '$scope',
    '$state',
    '$window',
    'applicationDetectionService',
    'logService',
    'supportLinkService',
    'meetingService',
    'helperService',
    'brandingService',
    'localizationService',
    function (
        $scope,
        $state,
        $window,
        applicationDetectionService,
        logService,
        supportLinkService,
        meetingService,
        helperService,
        brandingService,
        localizationService
    ) {
        var self = this;

        self.modalState = 'closed';
        self.startedDownload = false;
        self.appDisplayName = 'AnyMeeting';

        self.startAppDownload = startAppDownload;
        self.getDetectionState = getDetectionState;
        self.joinNow = joinNow;
        self.onHavingTroubleLinkClick = onHavingTroubleLinkClick;
        self.onSupportLinkClick = onSupportLinkClick;

        self.showBrowserSuggestion = false;

        $scope.$on('camaro-detection-state-updated', digest);

        init();

        ////////////////////////

        function init() {
            logService.log('Camaro Detector Ctrl Init');

            if (!applicationDetectionService.appDownloadLocation) {
                applicationDetectionService.setupDownloadLocation();
            }

            //we are showing a different message specifically for non English locals for the NEC (ubmeet) reseller
            self.showBrowserSuggestion = !localizationService.isEnLocale() && brandingService.isUB();

            applicationDetectionService.getLaunchToken();

            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            self.appDisplayName = brandingService.getUniteDtAppName();
        }

        function startAppDownload() {
            logService.log('Camaro Detector Ctrl - Starting App Download');
            $window.location.href = applicationDetectionService.camaroAppDownloadLocation;
            self.startedDownload = true;
            digest();
        }

        function getDetectionState() {
            return applicationDetectionService.detectionState;
        }

        function joinNow() {
            logService.log("Camaro Detector Ctrl - Clicked 'Join Now'");
            applicationDetectionService.updateDetectionState('checking');
            self.startedDownload = false;
            applicationDetectionService.getLaunchToken();
        }

        function onHavingTroubleLinkClick() {
            logService.log("Camaro Detector Ctrl - Clicked 'Refresh Page'");

            if (helperService.isChrome()) {
                applicationDetectionService.updateDetectionState('failed');
                self.startedDownload = false;
                $window.location.href = helperService.setQueryParameter(
                    $window.location.href,
                    'skipAppDetection',
                    'true'
                );
            } else {
                self.joinNow();
            }
        }

        function onSupportLinkClick() {
            logService.log('Camaro Detector Ctrl - Clicked Support Link');
            meetingService.openExternalLink(supportLinkService.getSupportLink('generic'));
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
